const CSS = `
.react-favoritar-skeleton{pointer-events:none;user-select:none;}
.react-favoritar-skeleton .rfs-icon,
.react-favoritar-skeleton .rfs-text{
  color:transparent !important;
  background:linear-gradient(90deg,#ececec 0%,#f7f7f7 50%,#ececec 100%);
  background-size:200% 100%;
  animation:reactFavoritarSkeletonShimmer 1.2s ease-in-out infinite;
}
.react-favoritar-skeleton .rfs-icon{border-radius:50%;}
.react-favoritar-skeleton .rfs-text{border-radius:0.5rem;}
@keyframes reactFavoritarSkeletonShimmer{
  0%{background-position:200% 0;}
  100%{background-position:-200% 0;}
}
`;

/**
 * Placeholder da ilha de favoritar enquanto bundle e perfil carregam. Mesma
 * estrutura do link real, com ícone e texto transparentes dando o tamanho.
 */
export default function FavoritarSkeleton() {
  return (
    <>
      <style>{CSS}</style>
      <button
        type="button"
        className="text-uppercase react-favoritar-skeleton"
        aria-hidden="true"
        tabIndex={-1}
      >
        <i className="fa fa-heart-o rfs-icon" aria-hidden="true" />
        <span className="rfs-text">Seguir esse carro</span>
      </button>
    </>
  );
}
